<section class="pt-16 px-container">
    <app-breadcrumb-backoffice [items]="[
        { label: 'Home', route: '/backoffice/home' },
        { label: pageTitle, route: area === 'compagnie' ? '/backoffice/area-compagnie' : (area === 'ditte' ? '/backoffice/ditte-interventi' : '/backoffice/calendario-interventi') }
    ]"></app-breadcrumb-backoffice>
</section>

<section class="px-container pb-4">
    @if (area === 'compagnie') {
        <div class="ac-compagnie-nav">
            <div class="ac-main-tabs" role="tablist">
                <button type="button" class="ac-main-tab" [class.active]="section === 'cruscotto'" (click)="section = 'cruscotto'">
                    Cruscotto
                    @if (badgeCrit > 0) { <span class="ac-badge">{{ badgeCrit }}</span> }
                </button>
                <button type="button" class="ac-main-tab" [class.active]="section === 'compagnie'" (click)="section = 'compagnie'">
                    Spettacoli
                    <span class="ac-badge">{{ section === 'compagnie' ? compagnieFiltrate.length : summariesStagione.length }}</span>
                </button>
                <button type="button" class="ac-main-tab" [class.active]="section === 'rubrica'" (click)="section = 'rubrica'">
                    Rubrica
                    <span class="ac-badge">{{ rubrica.length }}</span>
                </button>
            </div>
            <button class="acc-btn acc-btn-primary" type="button" (click)="documenti = true">Gestisci documenti teatro</button>
        </div>
    }
</section>

@if (loading) {
    <app-loading-backoffice [visible]="true"></app-loading-backoffice>
}

<!-- ============ CRUSCOTTO ============ -->
@if (!loading && section === 'cruscotto') {
<section class="px-container pb-16">
    <div class="ac-two-col ac-cruscotto-cols">
        <div class="ac-cruscotto-col">
            <div class="ac-section-head">
                <h2>Prossimi spettacoli · 14 giorni</h2>
                <span class="ac-meta">stato accreditamento · click per aprire</span>
            </div>

            <div class="ac-events-list">
                @for (e of summaries14; track e.id) {
                    <button type="button" class="ac-event-row ac-event-row-compact" (click)="openEvento(e.id)">
                        <div class="ac-event-date">
                            <strong>{{ e.dal | date: 'dd' }}</strong>
                            <span>{{ e.dal | date: 'MMM' | uppercase }}</span>
                        </div>
                        <div class="ac-event-title">
                            {{ e.evento }}
                            <span class="sub">{{ e.ragione_sociale }} · {{ e.n_personale }} {{ e.n_personale === 1 ? 'membro del personale' : 'membri del personale' }} · {{ e.n_subappalti }} subappalti</span>
                        </div>
                        <!-- <div class="ac-status-bar">
                            <div [class]="statusClass(e.status.doc)" title="Documenti">Doc</div>
                        </div> -->
                        <div class="ac-event-summary" [ngClass]="e.summary.level">                            
                            @if (missingItems(e).length) {
                                <div class="ac-missing-chips">
                                    @for (m of missingItems(e).slice(0, 5); track m) {
                                        <span class="ac-missing-chip">{{ m }}</span>
                                    }
                                    @if (missingItems(e).length > 5) {
                                        <span class="ac-missing-chip more">+{{ missingItems(e).length - 5 }}</span>
                                    }
                                </div>
                            }
                        </div>
                        <div class="ac-event-arrow">→</div>
                    </button>
                } @empty {
                    <div class="ac-empty">Nessuno spettacolo nei prossimi 14 giorni.</div>
                }
            </div>

            <div class="ac-legend">
                <span class="legend-label">Legenda</span>
                <span class="legend-item"><span class="swatch ok"></span> OK</span>
                <span class="legend-item"><span class="swatch wait"></span> documenti da accettare</span>
                <span class="legend-item"><span class="swatch warn"></span> documenti da completare o documenti mancanti</span>                
            </div>
        </div>

        <div class="ac-cruscotto-col">
            <div class="ac-section-head">
                <h2>Scadenze / criticità</h2>
                <span class="ac-meta">prossimi 90 giorni · cosa manca</span>
            </div>
            <div class="ac-side-list">
                @for (e of scadenze; track e.id) {
                    <div class="ac-side-row" (click)="openEvento(e.id)">
                        <div class="ac-event-date">
                            <strong>{{ e.dal | date: 'dd' }}</strong>
                            <span>{{ e.dal | date: 'MMM' | uppercase }}</span>
                        </div>
                        <div>
                            <strong>{{ e.evento }}</strong>
                            <div class="ac-side-summary" [ngClass]="e.summary.level">{{ e.summary.text }}</div>                            
                        </div>
                    </div>
                } @empty {
                    <div class="ac-empty">Nessuna criticità nei prossimi 90 giorni.</div>
                }
            </div>
        </div>
    </div>
</section>
}

<!-- ============ SPETTACOLI ============ -->
@if (!loading && section === 'compagnie') {
<section class="px-container pb-16">
    <div class="ac-section-head">
        <h2>Spettacoli</h2>
        <span class="ac-meta">{{ compagnieFiltrate.length }} in elenco · {{ summaries.length }} totali</span>
    </div>

    <div class="ac-toolbar">
        <input type="text" pInputText class="w-full" placeholder="Cerca spettacolo, compagnia…" [(ngModel)]="filterSearch" />
        <div class="ac-pills">
            <button type="button" class="ac-pill" [class.active]="filterPeriod === '14'" (click)="setPeriod('14')">14 GG</button>
            <button type="button" class="ac-pill" [class.active]="filterPeriod === '90'" (click)="setPeriod('90')">90 GG</button>
            <button type="button" class="ac-pill" [class.active]="filterPeriod === 'stagione'" (click)="setPeriod('stagione')">stagione</button>
            <button type="button" class="ac-pill" [class.active]="filterPeriod === 'tutti'" (click)="setPeriod('tutti')">tutti</button>
            <span class="ac-pill-sep"></span>
            <button type="button" class="ac-pill" [class.active]="filterState === 'all'" (click)="setState('all')">tutte</button>
            <button type="button" class="ac-pill" [class.active]="filterState === 'crit'" (click)="setState('crit')">criticità</button>
            <button type="button" class="ac-pill" [class.active]="filterState === 'ok'" (click)="setState('ok')">pronte</button>
        </div>
    </div>    

    <div class="ac-events-list">
        @for (e of compagnieFiltrate; track e.id) {
            <button type="button" class="ac-event-row" (click)="openEvento(e.id)">
                <div class="ac-event-date text-center">
                    <strong>{{ e.dal | date: 'dd' }}</strong>
                    <span>{{ e.dal | date: 'MMM/yy' | uppercase }}</span>
                </div>
                <div class="ac-event-title">
                    {{ e.evento }}
                    <span class="sub">{{ e.ragione_sociale }} · {{ e.n_personale }} {{ e.n_personale === 1 ? 'membro del personale' : 'membri del personale' }} · {{ e.n_subappalti }} subappalti</span>
                </div>                
                <div class="ac-event-summary" [ngClass]="e.summary.level">                    
                    @if (missingItems(e).length) {
                        <div class="ac-missing-chips">
                            @for (m of missingItems(e).slice(0, 5); track m) {
                                <span class="ac-missing-chip">{{ m }}</span>
                            }
                            @if (missingItems(e).length > 5) {
                                <span class="ac-missing-chip more">+{{ missingItems(e).length - 5 }}</span>
                            }
                        </div>
                    }
                </div>
                <div class="ac-event-arrow">→</div>
            </button>
        } @empty {
            <div class="ac-empty">Nessuno spettacolo trovato.</div>
        }
    </div>
</section>
}

<!-- ============ MANUTENZIONI E VERIFICHE (ditte / interventi) ============ -->
@if (!loading && section === 'ditte') {
<section class="px-container pb-16">
    <div class="ac-section-head">
        <div>
            <h2>Fornitori, Manutenzioni e Verifiche</h2>
            <p class="ac-subtitle">Scadenze, registro impianti, ditte e storico interventi.</p>
        </div>
        <div class="flex gap-2 flex-wrap">
            <a class="acc-btn" routerLink="/backoffice/calendario-interventi">Calendario</a>
            <button type="button" class="acc-btn" (click)="openNuovoIntervento()">Registra intervento</button>
            <button type="button" class="acc-btn acc-btn-primary" (click)="openNuovoImpianto()">+ Aggiungi verifica</button>
        </div>
    </div>

    <div class="ac-main-tabs" role="tablist">
        <button type="button" class="ac-main-tab" [class.active]="ditteTab === 'scadenze'" (click)="ditteTab = 'scadenze'">Scadenze</button>
        <button type="button" class="ac-main-tab" [class.active]="ditteTab === 'verifiche'" (click)="ditteTab = 'verifiche'">Verifiche</button>
        <button type="button" class="ac-main-tab" [class.active]="ditteTab === 'ditte'" (click)="ditteTab = 'ditte'">Anagrafiche fornitori</button>
        <button type="button" class="ac-main-tab" [class.active]="ditteTab === 'interventi'" (click)="ditteTab = 'interventi'">Interventi</button>
    </div>

    @if (ditteTab === 'scadenze') {
        <div class="ac-section-head mt-4">
            <div>
                <h3>Prossime scadenze</h3>
                <p class="ac-subtitle">Solo ciò che richiede attenzione, in ordine di data.</p>
            </div>
        </div>
        <div class="ac-tbl-wrap">
            <table class="ac-tbl">
                <thead>
                    <tr>
                        <th>Data</th>
                        <th>Scadenza</th>
                        <th>Dettaglio</th>
                        <th>Stato</th>
                    </tr>
                </thead>
                <tbody>
                    @for (s of scadenzeManutenzione; track s.kind + s.date + s.title) {
                        <tr class="ac-tbl-row" (click)="s.impianto ? openDettaglioImpianto(s.impianto!) : setDitteTab('ditte')">
                            <td>
                                <span class="ac-date">{{ s.date | date: 'dd/MM/yyyy' }}</span>
                            </td>
                            <td>
                                <div class="ac-mini-title">{{ s.title }}</div>
                            </td>
                            <td>
                                <div class="ac-mini-note">{{ s.note }}</div>
                            </td>
                            <td>
                                <span class="mini-pill" [class.crit]="s.level === 'crit'" [class.warn]="s.level === 'warn'" [class.ok]="s.level === 'ok'" [class.wait]="s.level === 'blue'">{{ s.label }}</span>
                            </td>
                        </tr>
                    } @empty {
                        <tr><td colspan="4" class="ac-empty">Nessuna scadenza nelle prossime settimane.</td></tr>
                    }
                </tbody>
            </table>
        </div>
        <p class="ac-spec-note mt-4"><b>Documenti ditta.</b> Visura, DURC, polizza RC, abilitazioni e contratto restano distinti dalle scadenze impianto.</p>
    }

    @if (ditteTab === 'verifiche') {
        <div class="ac-section-head mt-4">
            <div>
                <h3>Impianti e verifiche</h3>
                <p class="ac-subtitle">Registro con periodicità. Cliccando una riga si apre la scheda con obblighi, storico, ditta e allegati.</p>
            </div>
            <button type="button" class="acc-btn acc-btn-primary" (click)="openNuovoImpianto()">+ Aggiungi verifica</button>
        </div>
        <div class="ac-toolbar ac-toolbar-inline">
            <input type="text" pInputText class="w-full" placeholder="Cerca impianto, verifica o ditta…" [(ngModel)]="impiantiSearch" />
            <p-dropdown
                [options]="categorieFiltro"
                [(ngModel)]="impiantiCategoria"
                optionLabel="label"
                optionValue="value"
                styleClass="ac-filter-dd"
                appendTo="body"
            ></p-dropdown>
            <p-dropdown
                [options]="statiDisplayFiltro"
                [(ngModel)]="impiantiStatoFilter"
                optionLabel="label"
                optionValue="value"
                styleClass="ac-filter-dd"
                appendTo="body"
            ></p-dropdown>
        </div>
        <div class="ac-tbl-wrap">
            <table class="ac-tbl">
                <thead>
                    <tr>
                        <th>Impianto / verifica</th>
                        <th>Periodicità</th>
                        <th>Ultimo intervento</th>
                        <th>Prossima scadenza</th>
                        <th>Ditta / incaricato</th>
                        <th>Documenti</th>
                        <th>Stato</th>
                        <th class="ac-tbl-actions-col">Azioni</th>
                    </tr>
                </thead>
                <tbody>
                    @for (imp of impiantiFiltrati; track imp.id) {
                        <tr class="ac-tbl-row" (click)="openDettaglioImpianto(imp)">
                            <td>
                                <div class="ac-mini-title">{{ imp.nome }}</div>
                                <div class="ac-mini-note">{{ imp.descrizione || imp.categoria }}</div>
                            </td>
                            <td>{{ periodicitaLabel(imp.periodicita) }}</td>
                            <td>{{ imp.ultimo_intervento ? (imp.ultimo_intervento | date: 'dd/MM/yyyy') : '—' }}</td>
                            <td>
                                @if (imp.prossima_scadenza) {
                                    <span class="ac-date">{{ imp.prossima_scadenza | date: 'dd/MM/yyyy' }}</span>
                                } @else {
                                    <span class="ac-mini-note">Da programmare</span>
                                }
                            </td>
                            <td>{{ imp.fornitore || imp.incaricato || '—' }}</td>
                            <td>{{ docsLabelImpianto(imp) }}</td>
                            <td>
                                <span class="mini-pill" [ngClass]="impiantoStatusClass(imp.stato_display || impiantoStatusLabel(imp))">
                                    {{ imp.stato_display || impiantoStatusLabel(imp) }}
                                </span>
                            </td>
                            <td class="ac-tbl-actions-col" (click)="$event.stopPropagation()">
                                <button type="button" class="ac-delete" (click)="deleteImpianto($event, imp)" title="Elimina"><i class="bi bi-trash"></i></button>
                            </td>
                        </tr>
                    } @empty {
                        <tr><td colspan="8" class="ac-empty">Nessun impianto. Aggiungi una verifica.</td></tr>
                    }
                </tbody>
            </table>
        </div>
        <p-confirmPopup key="deleteImpianto" #deleteImpiantoPopup>
            <ng-template pTemplate="headless" let-message>
                <div class="border-round p-3">
                    <span class="text-base">{{ message.message }}</span>
                    <div class="flex align-items-center gap-2 mt-3">
                        <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onCloseDeleteConfirm('impianto')">Annulla</button>
                        <button type="button" class="acc-btn flex-1" (click)="onAcceptDeleteConfirm('impianto')">Elimina</button>
                    </div>
                </div>
            </ng-template>
        </p-confirmPopup>
        <div class="ac-legend mt-3">
            <span class="mini-pill crit">Scaduta</span>
            <span class="mini-pill warn">In scadenza</span>
            <span class="mini-pill wait">Programmata</span>
            <span class="mini-pill ok">Regolare</span>
            <span class="mini-pill">Da completare</span>
        </div>
    }

    @if (ditteTab === 'ditte') {
        <div class="ac-section-head mt-4">
            <div>
                <h3>Anagrafiche fornitori</h3>
                <p class="ac-subtitle">Anagrafica, documenti validi e impianti affidati.</p>
            </div>
            <button type="button" class="acc-btn acc-btn-primary" (click)="openNuovaRubrica('ditta')">+ Nuova ditta</button>
        </div>
        <div class="ac-toolbar">
            <input type="text" pInputText class="w-full" placeholder="Cerca ditta o specializzazione…" [(ngModel)]="rubricaSearch" />
            <div class="ac-pills">
                <button type="button" class="ac-pill" [class.active]="ditteStatoFilter === 'all'" (click)="ditteStatoFilter = 'all'">Tutte</button>
                <button type="button" class="ac-pill" [class.active]="ditteStatoFilter === 'accreditata'" (click)="ditteStatoFilter = 'accreditata'">Accreditate</button>
                <button type="button" class="ac-pill" [class.active]="ditteStatoFilter === 'documenti'" (click)="ditteStatoFilter = 'documenti'">Documenti in scadenza</button>
                <button type="button" class="ac-pill" [class.active]="ditteStatoFilter === 'da_completare'" (click)="ditteStatoFilter = 'da_completare'">Da completare</button>
            </div>
        </div>
        <div class="ac-tbl-wrap">
            <table class="ac-tbl">
                <thead>
                    <tr>
                        <th>Ragione sociale</th>
                        <th>Referente</th>
                        <th>Specializzazione</th>
                        <th>Impianti / interventi</th>
                        <th>Documenti</th>
                        <th>Stato</th>
                        <th class="ac-tbl-actions-col">Azioni</th>
                    </tr>
                </thead>
                <tbody>
                    @for (d of ditteFiltrate; track d.id) {
                        <tr class="ac-tbl-row" (click)="openEditRubrica(d)">
                            <td>
                                <div class="ac-mini-title">{{ d.ragione_sociale }}</div>
                                @if (d.piva) { <div class="ac-mini-note">{{ d.piva }}</div> }
                            </td>
                            <td>{{ d.referente || '—' }}</td>
                            <td>{{ d.specializzazione || '—' }}</td>
                            <td>{{ countImpiantiDitta(d) }} impianti · {{ countInterventiDitta(d) }} interventi</td>
                            <td>{{ dittaDocFoot(d) }}</td>
                            <td>
                                <span class="mini-pill" [ngClass]="statoAccPill(d).cls">{{ statoAccPill(d).text }}</span>
                            </td>
                            <td class="ac-tbl-actions-col" (click)="$event.stopPropagation()">
                                <button type="button" class="ac-delete" (click)="deleteRubrica($event, d)" title="Elimina"><i class="bi bi-trash"></i></button>
                            </td>
                        </tr>
                    } @empty {
                        <tr><td colspan="7" class="ac-empty">Nessuna anagrafica fornitore. Crea una nuova anagrafica.</td></tr>
                    }
                </tbody>
            </table>
        </div>
        <p-confirmPopup key="deleteDitta" #deleteDittaPopup>
            <ng-template pTemplate="headless" let-message>
                <div class="border-round p-3">
                    <span class="text-base">{{ message.message }}</span>
                    <div class="flex align-items-center gap-2 mt-3">
                        <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onCloseDeleteConfirm('ditta')">Annulla</button>
                        <button type="button" class="acc-btn flex-1" (click)="onAcceptDeleteConfirm('ditta')">Elimina</button>
                    </div>
                </div>
            </ng-template>
        </p-confirmPopup>
        <p class="ac-spec-note mt-4"><b>Documenti ditta suggeriti.</b> Visura e dati fiscali, DURC, polizza RC, abilitazioni o certificazioni, contratto/incarico e referenti.</p>
    }

    @if (ditteTab === 'interventi') {
        <div class="ac-section-head mt-4">
            <div>
                <h3>Storico interventi</h3>
                <p class="ac-subtitle">Manutenzioni, verifiche e risoluzione anomalie.</p>
            </div>
            <button type="button" class="acc-btn acc-btn-primary" (click)="openNuovoIntervento()">+ Registra intervento</button>
        </div>
        <div class="ac-toolbar">
            <input type="text" pInputText class="w-full" placeholder="Cerca impianto, ditta, esito…" [(ngModel)]="interventiSearch" />
            <div class="ac-pills">
                <button type="button" class="ac-pill" [class.active]="interventiTipo === 'all'" (click)="interventiTipo = 'all'">Tutti i tipi</button>
                <button type="button" class="ac-pill" [class.active]="interventiTipo === 'verifica'" (click)="interventiTipo = 'verifica'">Verifica</button>
                <button type="button" class="ac-pill" [class.active]="interventiTipo === 'ordinario'" (click)="interventiTipo = 'ordinario'">Ord.</button>
                <button type="button" class="ac-pill" [class.active]="interventiTipo === 'straordinario'" (click)="interventiTipo = 'straordinario'">Straord.</button>
                <button type="button" class="ac-pill" [class.active]="interventiTipo === 'anomalia'" (click)="interventiTipo = 'anomalia'">Anomalia</button>
                <span class="ac-pill-sep"></span>
                <button type="button" class="ac-pill" [class.active]="interventiEsito === 'all'" (click)="interventiEsito = 'all'">Tutti esiti</button>
                <button type="button" class="ac-pill" [class.active]="interventiEsito === 'positivo'" (click)="interventiEsito = 'positivo'">Positivo</button>
                <button type="button" class="ac-pill" [class.active]="interventiEsito === 'prescrizioni'" (click)="interventiEsito = 'prescrizioni'">Prescrizioni</button>
                <button type="button" class="ac-pill" [class.active]="interventiEsito === 'negativo'" (click)="interventiEsito = 'negativo'">Negativo</button>
            </div>
        </div>
        <div class="ac-tbl-wrap">
            <table class="ac-tbl">
                <thead>
                    <tr>
                        <th>Data</th>
                        <th>Intervento</th>
                        <th>Tipo</th>
                        <th>Ditta / impianto</th>
                        <th>Esito</th>
                        <th>Allegati</th>
                        <th class="ac-tbl-actions-col">Azioni</th>
                    </tr>
                </thead>
                <tbody>
                    @for (i of interventiStorico; track i.id) {
                        <tr class="ac-tbl-row" (click)="openEditIntervento(i)">
                            <td>
                                <span class="ac-date">{{ i.data_ora | date: 'dd/MM/yyyy' }}</span>
                            </td>
                            <td>
                                <div class="ac-mini-title">{{ i.titolo }}</div>
                                @if (i.note_interne) { <div class="ac-mini-note">{{ i.note_interne }}</div> }
                            </td>
                            <td>{{ tipoInterventoLabel(i.tipo) }}</td>
                            <td>
                                <div>{{ i.fornitore || '—' }}</div>
                                @if (i.impianto) { <div class="ac-mini-note">{{ i.impianto }}</div> }
                            </td>
                            <td>
                                <span class="mini-pill" [ngClass]="esitoPillClass(i.esito)">{{ esitoLabel(i.esito) }}</span>
                                @if (i.prossima_scadenza) {
                                    <div class="ac-mini-note">Prossima: {{ i.prossima_scadenza | date: 'dd/MM/yyyy' }}</div>
                                }
                            </td>
                            <td>
                                @if (i.ordine_lavoro || i.preventivo) {
                                    {{ (i.ordine_lavoro ? 1 : 0) + (i.preventivo ? 1 : 0) }} file
                                } @else {
                                    <span class="ac-mini-note">Nessun allegato</span>
                                }
                            </td>
                            <td class="ac-tbl-actions-col" (click)="$event.stopPropagation()">
                                <button type="button" class="ac-delete" (click)="deleteIntervento($event, i)" title="Elimina"><i class="bi bi-trash"></i></button>
                            </td>
                        </tr>
                    } @empty {
                        <tr><td colspan="7" class="ac-empty">Nessun intervento trovato.</td></tr>
                    }
                </tbody>
            </table>
        </div>
        <p-confirmPopup key="deleteIntervento" #deleteInterventoPopup>
            <ng-template pTemplate="headless" let-message>
                <div class="border-round p-3">
                    <span class="text-base">{{ message.message }}</span>
                    <div class="flex align-items-center gap-2 mt-3">
                        <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onCloseDeleteConfirm('intervento')">Annulla</button>
                        <button type="button" class="acc-btn flex-1" (click)="onAcceptDeleteConfirm('intervento')">Elimina</button>
                    </div>
                </div>
            </ng-template>
        </p-confirmPopup>
        <p class="ac-spec-note mt-4"><b>Regola dati.</b> Un intervento non sovrascrive mai il precedente. Collegato a un impianto, aggiorna ultimo controllo e prossima scadenza dalla periodicità.</p>
    }

</section>
}

<!-- ============ CALENDARIO INTERVENTI ============ -->
@if (!loading && section === 'calendario') {
<section class="px-container pb-16">
    <div class="ac-section-head">
        <h2>Calendario interventi e scadenze</h2>
        <div class="flex gap-2 flex-wrap">
            <a class="acc-btn" routerLink="/backoffice/ditte-interventi">Fornitori, Manutenzioni e Verifiche</a>
            <button type="button" class="acc-btn" (click)="openNuovoImpianto()">+ Verifica</button>
            <button type="button" class="acc-btn acc-btn-primary" (click)="openNuovoIntervento()">+ Nuovo intervento</button>
        </div>
    </div>

    <div class="ac-cal-toolbar">
        <div class="ac-main-tabs" role="tablist">
            <button type="button" class="ac-main-tab" [class.active]="calendarioView === 'calendario'" (click)="calendarioView = 'calendario'">Calendario</button>
            <button type="button" class="ac-main-tab" [class.active]="calendarioView === 'lista'" (click)="calendarioView = 'lista'">Lista</button>            
        </div>
        <div class="flex items-center gap-2">
            <button type="button" class="ac-cal-nav" (click)="prevMonth()" aria-label="Mese precedente">‹</button>
            <div class="flex items-center gap-1">
                <button type="button" class="ac-cal-title-btn" (click)="togglePicker('month')">{{ MONTHS[calMonth] }}</button>
                <button type="button" class="ac-cal-title-btn" (click)="togglePicker('year')">{{ calYear }}</button>
            </div>
            <button type="button" class="ac-cal-nav" (click)="nextMonth()" aria-label="Mese successivo">›</button>
        </div>
    </div>

    @if (pickerMode === 'month') {
        <div class="ac-cal-panel">
            <div class="ac-cal-picker grid grid-cols-3 gap-2">
                @for (m of MONTHS; track $index) {
                    <button type="button" class="ac-cal-pick" [class.active]="$index === calMonth" (click)="selectMonth($index)">{{ m.slice(0, 3) }}</button>
                }
            </div>
        </div>
    }

    @if (pickerMode === 'year') {
        <div class="ac-cal-panel">
            <div class="flex flex-col gap-3">
                <div class="flex items-center justify-between">
                    <button type="button" class="ac-cal-nav sm" (click)="navigatePrevYear()">‹</button>
                    <span class="text-sm text-gray-500">{{ yearRangeStart }} – {{ yearRangeStart + 11 }}</span>
                    <button type="button" class="ac-cal-nav sm" (click)="navigateNextYear()">›</button>
                </div>
                <div class="ac-cal-picker grid grid-cols-4 gap-2">
                    @for (y of yearRange; track y) {
                        <button type="button" class="ac-cal-pick" [class.active]="y === calYear" (click)="selectYear(y)">{{ y }}</button>
                    }
                </div>
            </div>
        </div>
    }

    @if (pickerMode === 'calendar' && calendarioView === 'lista') {
        <div class="ac-section-head mt-2">
            <div>
                <h3>{{ MONTHS[calMonth] }} {{ calYear }}</h3>
                <p class="ac-subtitle">Tutte le scadenze e gli interventi del mese, in tabella.</p>
            </div>
        </div>
        <div class="ac-tbl-wrap">
            <table class="ac-tbl ac-tbl-cal ac-tbl-cal-lista">
                <thead>
                    <tr>
                        <th>Data</th>
                        <th>Tipo</th>
                        <th>Titolo</th>
                        <th>Ditta / dettaglio</th>
                        <th>Stato</th>
                        <th class="ac-tbl-actions-col">Azioni</th>
                    </tr>
                </thead>
                <tbody>
                    @for (row of calendarioListaRows; track row.kind + row.date + row.title + (row.intervento?.id || row.impianto?.id)) {
                        <tr class="ac-tbl-row" (click)="openCalendarioListaRow(row)">
                            <td><span class="ac-date">{{ row.date | date: 'dd/MM/yyyy' }}</span></td>
                            <td>
                                <span class="mini-pill" [class.wait]="row.kind === 'intervento'" [class.ok]="row.kind === 'scadenza'">
                                    {{ row.kind === 'intervento' ? 'Intervento' : 'Scadenza' }}
                                </span>
                            </td>
                            <td>
                                <div class="ac-mini-title">{{ row.title }}</div>
                            </td>
                            <td>
                                <div class="ac-mini-note">{{ row.subtitle || '—' }}</div>
                            </td>
                            <td>
                                <span class="mini-pill" [class.crit]="row.level === 'crit' || row.level === 'negativo'" [class.warn]="row.level === 'warn' || row.level === 'prescrizioni'" [class.ok]="row.level === 'ok' || row.level === 'positivo'" [class.wait]="row.level === 'wait'">{{ row.stato }}</span>
                            </td>
                            <td class="ac-tbl-actions-col" (click)="$event.stopPropagation()">
                                @if (row.intervento) {
                                    <button type="button" class="ac-delete" (click)="deleteIntervento($event, row.intervento!)" title="Elimina"><i class="bi bi-trash"></i></button>
                                } @else {
                                    <button type="button" class="doc-btn" (click)="openDettaglioImpianto(row.impianto!)">Apri</button>
                                }
                            </td>
                        </tr>
                    } @empty {
                        <tr><td colspan="6" class="ac-empty">Nessuna scadenza o intervento in questo mese.</td></tr>
                    }
                </tbody>
            </table>
        </div>
        <div class="ac-cal-legend mt-3">
            <span><i class="swatch ok"></i> OK / positivo</span>
            <span><i class="swatch wait"></i> In attesa / intervento</span>
            <span><i class="swatch warn"></i> In scadenza / attenzione</span>
            <span><i class="swatch crit"></i> Scaduta / critico</span>
            <span><i class="swatch scadenza"></i> Scadenza verifica</span>
        </div>
    }

    @if (pickerMode === 'calendar' && calendarioView === 'calendario') {
    <div class="ac-cal-panel">
            <div class="grid grid-cols-7 text-center text-xs font-medium text-gray-400 mb-1">
                @for (d of DOW; track d) {
                    <div class="py-1">{{ d }}</div>
                }
            </div>
            <div class="grid grid-cols-7 gap-1.5">
                @for (day of calendarDays; track $index) {
                    @if (!day.date) {
                        <div class="ac-cal-day empty"></div>
                    } @else {
                        <button
                            type="button"
                            class="ac-cal-day"
                            [class.today]="day.isToday"
                            [class.selected]="day.date === calendarioDayFilter"
                            [class.has-items]="day.chips.length > 0"
                            (click)="selectCalDay(day.date)">
                            <span class="ac-cal-daynum" [class.today]="day.isToday">{{ day.dayNum }}</span>
                            @for (chip of day.chips.slice(0, 4); track chip.kind + (chip.kind === 'intervento' ? chip.item.id : 's' + chip.item.id)) {
                                @if (chip.kind === 'intervento') {
                                    <span
                                        [class]="calEventClass(chip.item)"
                                        [pTooltip]="(chip.item.fornitore || '') + ' · ' + chip.item.titolo"
                                        tooltipPosition="top"
                                        (click)="$event.stopPropagation(); openEditIntervento(chip.item)">
                                        {{ calEventLabel(chip.item) }}
                                    </span>
                                } @else {
                                    <span
                                        [class]="calScadenzaClass(chip.item)"
                                        [pTooltip]="'Scadenza verifica · ' + chip.item.nome + (chip.item.fornitore ? ' · ' + chip.item.fornitore : '')"
                                        tooltipPosition="top"
                                        (click)="$event.stopPropagation(); openDettaglioImpianto(chip.item)">
                                        {{ calScadenzaLabel(chip.item) }}
                                    </span>
                                }
                            }
                            @if (day.chips.length > 4) {
                                <span class="ac-cal-more">+{{ day.chips.length - 4 }} altri</span>
                            }
                        </button>
                    }
                }
            </div>

            <div class="ac-cal-legend">
                <span><i class="swatch ok"></i> Intervento OK</span>
                <span><i class="swatch wait"></i> In attesa</span>
                <span><i class="swatch warn"></i> Attenzione</span>
                <span><i class="swatch crit"></i> Critico</span>
                <span><i class="swatch scadenza"></i> Scadenza verifica</span>
            </div>
    </div>

    @if (calendarioDayFilter) {
        <div class="ac-section-head mt-8">
            <h3>Attività del {{ calendarioDayFilter | date: 'dd/MM/yyyy' }}</h3>
            <button type="button" class="acc-btn acc-btn-ghost" (click)="clearDayFilter()">Chiudi</button>
        </div>

        @if (dayScadenzeImpianto.length) {
            <h4 class="ac-day-section-title">Scadenze verifiche</h4>
            <div class="ac-tbl-wrap">
                <table class="ac-tbl ac-tbl-cal">
                    <thead>
                        <tr>
                            <th>Impianto / verifica</th>
                            <th>Periodicità</th>
                            <th>Ditta</th>
                            <th>Stato</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (imp of dayScadenzeImpianto; track imp.id) {
                            <tr class="ac-tbl-row" (click)="openDettaglioImpianto(imp)">
                                <td>
                                    <div class="ac-mini-title">{{ imp.nome }}</div>
                                    @if (imp.descrizione) { <div class="ac-mini-note">{{ imp.descrizione }}</div> }
                                </td>
                                <td>{{ periodicitaLabel(imp.periodicita) }}</td>
                                <td>{{ imp.fornitore || imp.incaricato || '—' }}</td>
                                <td>
                                    <span class="mini-pill" [ngClass]="impiantoStatusClass(imp.stato_display || impiantoStatusLabel(imp))">
                                        {{ imp.stato_display || impiantoStatusLabel(imp) }}
                                    </span>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }

        <h4 class="ac-day-section-title">Interventi</h4>
        <div class="ac-tbl-wrap">
            <table class="ac-tbl ac-tbl-cal">
                <thead>
                    <tr>
                        <th>Ora</th>
                        <th>Intervento</th>
                        <th>Tipo</th>
                        <th>Ditta / impianto</th>
                        <th>Esito</th>
                        <th class="ac-tbl-actions-col">Azioni</th>
                    </tr>
                </thead>
                <tbody>
                    @for (i of dayInterventi; track i.id) {
                        <tr class="ac-tbl-row" (click)="openEditIntervento(i)">
                            <td><span class="ac-date">{{ i.data_ora | date: 'HH:mm' }}</span></td>
                            <td>
                                <div class="ac-mini-title">{{ i.titolo }}</div>
                                @if (i.note_interne) { <div class="ac-mini-note">{{ i.note_interne }}</div> }
                            </td>
                            <td>{{ tipoInterventoLabel(i.tipo) }}</td>
                            <td>
                                <div>{{ i.fornitore || '—' }}</div>
                                @if (i.impianto) { <div class="ac-mini-note">{{ i.impianto }}</div> }
                            </td>
                            <td>
                                <span class="mini-pill" [ngClass]="esitoPillClass(i.esito)">{{ esitoLabel(i.esito) }}</span>
                            </td>
                            <td class="ac-tbl-actions-col" (click)="$event.stopPropagation()">
                                <button type="button" class="ac-delete" (click)="deleteIntervento($event, i)" title="Elimina"><i class="bi bi-trash"></i></button>
                            </td>
                        </tr>
                    } @empty {
                        <tr><td colspan="6" class="ac-empty">Nessun intervento in questo giorno.</td></tr>
                    }
                </tbody>
            </table>
        </div>
    }
    }
</section>
}

<!-- ============ RUBRICA ============ -->
@if (!loading && section === 'rubrica') {
<section class="px-container pb-16">
    <div class="ac-section-head">
        <h2>Rubrica</h2>
        <div class="flex gap-2 flex-wrap">
            <button type="button" class="acc-btn" (click)="importRubrica()">Importa da eventi</button>
            <button type="button" class="acc-btn" (click)="openNuovaRubrica('compagnia')">+ Compagnia</button>
            <button type="button" class="acc-btn acc-btn-primary" (click)="openNuovaRubrica('ditta')">+ Ditta</button>
        </div>
    </div>    

    <div class="ac-toolbar">
        <input type="text" pInputText class="w-full" placeholder="Cerca ragione sociale, P.IVA, telefono, email…" [(ngModel)]="rubricaSearch" />
    </div>

    <p-table [value]="rubricaFiltrata" responsiveLayout="stack" [breakpoint]="'960px'" styleClass="scheda-tabella p-datatable-sm" [rowHover]="true" [paginator]="true" [rows]="500">
        <ng-template pTemplate="header">
            <tr>
                <th>Ragione sociale</th>
                <th>Tipo</th>
                <th>P.IVA</th>
                <th>Referente</th>
                <th>Telefono</th>
                <th>Email</th>
                <th class="text-center">Doc</th>
                <th class="text-center">Azioni</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-a>
            <tr>
                <td>
                    <span class="cell-nome">{{ a.ragione_sociale }}</span>
                    @if (a.abituale) { <span class="ac-tag ml-2">abituale</span> }
                </td>
                <td><span class="ac-tag">{{ a.tipo }}</span></td>
                <td>{{ a.piva || '—' }}</td>
                <td>{{ a.referente || '—' }}</td>
                <td>{{ a.telefono || '—' }}</td>
                <td>{{ a.email || '—' }}</td>
                <td class="text-center">
                    <span class="status-seg" [ngClass]="docScadenzaLevel(a)">{{ docScadenzaLevel(a) }}</span>
                </td>
                <td>
                    <div class="table-actions">
                        <i class="bi bi-calendar-plus" pTooltip="Crea evento" tooltipPosition="bottom" (click)="openCreaEvento(a)"></i>
                        <i class="bi bi-pencil" pTooltip="Modifica" tooltipPosition="bottom" (click)="openEditRubrica(a)"></i>
                        <i class="bi bi-trash" pTooltip="Elimina" tooltipPosition="bottom" (click)="deleteRubrica($event, a)"></i>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr><td colspan="8">Nessuna anagrafica. Usa “Importa da eventi” o crea una nuova voce.</td></tr>
        </ng-template>
    </p-table>
    <p-confirmPopup key="deleteRubrica" #deleteRubricaPopup>
        <ng-template pTemplate="headless" let-message>
            <div class="border-round p-3">
                <span class="text-base">{{ message.message }}</span>
                <div class="flex align-items-center gap-2 mt-3">
                    <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onCloseDeleteConfirm('rubrica')">Annulla</button>
                    <button type="button" class="acc-btn flex-1" (click)="onAcceptDeleteConfirm('rubrica')">Elimina</button>
                </div>
            </div>
        </ng-template>
    </p-confirmPopup>
</section>
}

<!-- Dialog Rubrica -->
<p-dialog [(visible)]="rubricaDialog" styleClass="accrediti-dialog" [modal]="true" [style]="{width: '60vw'}" [header]="rubricaEdit ? 'Modifica anagrafica' : (formRubrica.get('tipo')?.value === 'ditta' ? 'Nuova anagrafica fornitore' : 'Nuova anagrafica')">
    <form [formGroup]="formRubrica" class="accrediti-form flex flex-col gap-4" (ngSubmit)="saveRubrica()">
        <div class="flex gap-4 flex-wrap">
            <div class="flex flex-col flex-1 min-w-[180px]">
                <label>Tipo</label>
                <p-dropdown styleClass="w-full" [options]="tipiFornitore" formControlName="tipo" optionLabel="label" optionValue="value" appendTo="body"></p-dropdown>
            </div>
            @if (formRubrica.get('tipo')?.value === 'ditta') {
                <div class="flex flex-col flex-1 min-w-[180px]">
                    <label>Stato accreditamento</label>
                    <p-dropdown styleClass="w-full" [options]="statiAccreditamento" formControlName="stato_accreditamento" optionLabel="label" optionValue="value" appendTo="body"></p-dropdown>
                </div>
            }
            <div class="flex items-end pb-2">
                <div class="flex items-center gap-2">
                    <p-checkbox formControlName="abituale" inputId="abituale" [binary]="true" />
                    <label for="abituale" class="cursor-pointer">Fornitore / compagnia abituale</label>
                </div>
            </div>
        </div>
        <div class="flex flex-col"><label>Ragione sociale *</label><input pInputText class="w-full" formControlName="ragione_sociale" /></div>
        <div class="flex gap-4 flex-wrap">
            <div class="flex flex-col flex-1"><label>Partita IVA</label><input pInputText class="w-full" formControlName="piva" placeholder="IT…" /></div>
            <div class="flex flex-col flex-1"><label>Telefono</label><input pInputText class="w-full" formControlName="telefono" /></div>
        </div>
        <div class="flex flex-col"><label>Sede</label><input pInputText class="w-full" formControlName="sede" /></div>
        <div class="flex gap-4 flex-wrap">
            <div class="flex flex-col flex-1"><label>Referente</label><input pInputText class="w-full" formControlName="referente" /></div>
            <div class="flex flex-col flex-1"><label>Email</label><input pInputText class="w-full" formControlName="email" /></div>
        </div>
        @if (formRubrica.get('tipo')?.value === 'ditta') {
            <div class="flex flex-col">
                <label>Specializzazione</label>
                <input pInputText class="w-full" formControlName="specializzazione" placeholder="Antincendio, elettrico… (tag separate da virgola)" />
            </div>
        }
        <div class="flex flex-col"><label>Note</label><textarea pInputTextarea class="w-full" formControlName="note" rows="2"></textarea></div>

        <div class="ac-docs-block">
            <h3 class="text-sm font-semibold uppercase tracking-wide mb-3">
                {{ formRubrica.get('tipo')?.value === 'ditta' ? 'Documenti di accreditamento' : 'Documenti e scadenze' }}
            </h3>
            @for (d of rubricaDocsAttivi; track d.key) {
                <div class="ac-doc-row">
                    <div class="flex flex-col gap-1 flex-1">
                        <label>{{ d.label }}</label>
                        <app-file-upload [form]="formRubrica" [control]="d.key" [label]="''" [multiple]="false" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Carica'"></app-file-upload>
                        @if (fileName(rubricaEdit, d.key)) {
                            <button type="button" class="doc-btn self-start" (click)="onDocumento(fileName(rubricaEdit, d.key))">Apri file attuale</button>
                        }
                    </div>
                    <div class="flex flex-col">
                        <label>Scadenza</label>
                        <p-calendar [formControlName]="d.scad" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body" styleClass="w-full"></p-calendar>
                    </div>
                </div>
            }
        </div>

        <div class="acc-actions">
            <button type="button" class="acc-btn acc-btn-ghost" (click)="rubricaDialog = false">Annulla</button>
            <button type="submit" class="acc-btn acc-btn-primary" [disabled]="formRubrica.invalid">Salva anagrafica</button>
        </div>
    </form>
</p-dialog>

<!-- Dialog Intervento -->
<p-dialog [(visible)]="interventoDialog" styleClass="accrediti-dialog" [modal]="true" [style]="{width: '60vw'}" [header]="interventoEdit ? 'Modifica intervento' : 'Registra intervento'">
    <form [formGroup]="formIntervento" class="accrediti-form flex flex-col gap-4" (ngSubmit)="saveIntervento()">
        <p class="ac-subtitle m-0">L'intervento aggiorna lo storico e, se collegato a un impianto e concluso, la prossima scadenza.</p>
        <div class="flex gap-4 flex-wrap">
            <div class="flex flex-col flex-1 min-w-[200px]">
                <label>Impianto / verifica</label>
                <p-dropdown
                    styleClass="w-full"
                    [options]="impianti"
                    formControlName="id_impianto"
                    optionLabel="nome"
                    optionValue="id"
                    [showClear]="true"
                    [filter]="true"
                    filterBy="nome,categoria"
                    placeholder="Seleziona (opzionale)"
                    appendTo="body"
                    (onChange)="onInterventoImpiantoChange()"
                ></p-dropdown>
            </div>
            <div class="flex flex-col flex-1 min-w-[200px]">
                <label>Titolo *</label>
                <input pInputText class="w-full" formControlName="titolo" placeholder="Es. Estintori e idranti" />
            </div>
        </div>
        <div class="flex gap-4 flex-wrap">
            <div class="flex flex-col flex-1 min-w-[200px]">
                <label>Tipo intervento *</label>
                <p-dropdown styleClass="w-full" [options]="tipiIntervento" formControlName="tipo" optionLabel="label" optionValue="value" appendTo="body"></p-dropdown>
            </div>
            <div class="flex flex-col flex-1 min-w-[200px]">
                <label>Ditta / responsabile</label>
                <p-dropdown styleClass="w-full" [options]="rubricaDitte" formControlName="id_fornitore" optionLabel="ragione_sociale" optionValue="id" [showClear]="true" [filter]="true" filterBy="ragione_sociale,piva" placeholder="Seleziona o lascia vuoto" appendTo="body"></p-dropdown>
            </div>
        </div>

        <div class="flex gap-4 flex-wrap">
            <div class="flex flex-col flex-1 min-w-[200px]">
                <label>{{ formIntervento.get('ricorrente')?.value ? 'Prossima occorrenza *' : 'Data intervento *' }}</label>
                <p-calendar formControlName="data_ora" dateFormat="dd/mm/yy" [showTime]="true" [showIcon]="true" hourFormat="24" appendTo="body" styleClass="w-full"></p-calendar>
            </div>
            <div class="flex flex-col flex-1 min-w-[160px]">
                <label>Esito</label>
                <p-dropdown styleClass="w-full" [options]="esitiIntervento" formControlName="esito" optionLabel="label" optionValue="value" [showClear]="true" placeholder="Seleziona" appendTo="body"></p-dropdown>
            </div>
            <div class="flex flex-col flex-1 min-w-[160px]">
                <label>Prossima scadenza</label>
                <p-calendar formControlName="prossima_scadenza" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body" styleClass="w-full"></p-calendar>
                <small class="text-gray-500">Proposta dalla periodicità, modificabile</small>
            </div>
        </div>

        <div class="flex gap-4 flex-wrap items-end">
            <div class="flex items-center gap-2 pb-2">
                <p-checkbox formControlName="ricorrente" inputId="ricorrente" [binary]="true" />
                <label for="ricorrente" class="cursor-pointer">Attività ricorrente?</label>
            </div>
            @if (formIntervento.get('ricorrente')?.value) {
                <div class="flex flex-col flex-1 min-w-[180px]">
                    <label>Ricorrenza *</label>
                    <p-dropdown styleClass="w-full" [options]="ricorrenze" formControlName="ricorrenza" optionLabel="label" optionValue="value" appendTo="body"></p-dropdown>
                </div>
            }
            <div class="flex flex-col min-w-[140px]"><label>Durata (ore)</label><p-inputNumber formControlName="durata_ore" [minFractionDigits]="0" [maxFractionDigits]="2" [min]="0" styleClass="w-full" inputStyleClass="w-full"></p-inputNumber></div>
            <div class="flex flex-col min-w-[140px]"><label>N. lavoratori</label><p-inputNumber formControlName="n_lavoratori" [min]="0" [showButtons]="false" styleClass="w-full" inputStyleClass="w-full"></p-inputNumber></div>
        </div>

        <div class="flex flex-col"><label>Intervento eseguito, note e prescritzioni</label><textarea pInputTextarea class="w-full" formControlName="note_interne" rows="3" placeholder="Descrizione sintetica…"></textarea></div>

        <div class="flex gap-4 flex-wrap">
            <div class="flex flex-col flex-1 gap-1">
                <label>Verbale / certificato</label>
                <app-file-upload [form]="formIntervento" [control]="'ordine_lavoro'" [label]="''" [multiple]="false" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Carica verbale'"></app-file-upload>
                @if (interventoEdit?.ordine_lavoro) {
                    <button type="button" class="doc-btn self-start" (click)="onDocumento(interventoEdit!.ordine_lavoro!)">Apri attuale</button>
                }
            </div>
            <div class="flex flex-col flex-1 gap-1">
                <label>Altri allegati</label>
                <app-file-upload [form]="formIntervento" [control]="'preventivo'" [label]="''" [multiple]="false" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Carica file'"></app-file-upload>
                @if (interventoEdit?.preventivo) {
                    <button type="button" class="doc-btn self-start" (click)="onDocumento(interventoEdit!.preventivo!)">Apri attuale</button>
                }
            </div>
        </div>

        <details class="ac-advanced">
            <summary>Stati operativi (avanzato)</summary>
            <div class="flex gap-4 flex-wrap mt-3">
                <div class="flex flex-col flex-1"><label>Documenti</label><p-dropdown styleClass="w-full" [options]="stati" formControlName="stato_doc" optionLabel="label" optionValue="value" appendTo="body"></p-dropdown></div>
                <div class="flex flex-col flex-1"><label>Operativo</label><p-dropdown styleClass="w-full" [options]="stati" formControlName="stato_op" optionLabel="label" optionValue="value" appendTo="body"></p-dropdown></div>
                <div class="flex flex-col flex-1"><label>Personale</label><p-dropdown styleClass="w-full" [options]="stati" formControlName="stato_pers" optionLabel="label" optionValue="value" appendTo="body"></p-dropdown></div>
                <div class="flex flex-col flex-1"><label>Criticità</label><p-dropdown styleClass="w-full" [options]="stati" formControlName="criticita" optionLabel="label" optionValue="value" appendTo="body"></p-dropdown></div>
            </div>
        </details>

        <div class="acc-actions">
            <button type="button" class="acc-btn acc-btn-ghost" (click)="interventoDialog = false">Annulla</button>
            <button type="submit" class="acc-btn acc-btn-primary" [disabled]="formIntervento.invalid">Salva intervento</button>
        </div>
    </form>
</p-dialog>

<!-- Dialog Impianto / verifica -->
<p-dialog [(visible)]="impiantoDialog" styleClass="accrediti-dialog" [modal]="true" [style]="{width: '60vw'}" [header]="impiantoEdit ? 'Modifica verifica' : 'Aggiungi verifica'">
    <form [formGroup]="formImpianto" class="accrediti-form flex flex-col gap-4" (ngSubmit)="saveImpianto()">
        <p class="ac-subtitle m-0">Definisci responsabilità e periodicità senza creare passaggi superflui.</p>
        <div class="flex flex-col"><label>Impianto / verifica *</label><input pInputText class="w-full" formControlName="nome" placeholder="Es. Impianto elettrico" /></div>
        <div class="flex flex-col"><label>Descrizione</label><textarea pInputTextarea class="w-full" formControlName="descrizione" rows="2" placeholder="Cosa viene controllato…"></textarea></div>
        <div class="flex gap-4 flex-wrap">
            <div class="flex flex-col flex-1 min-w-[160px]">
                <label>Categoria *</label>
                <p-dropdown styleClass="w-full" [options]="categorieImpianto" formControlName="categoria" optionLabel="label" optionValue="value" appendTo="body"></p-dropdown>
            </div>
            <div class="flex flex-col flex-1 min-w-[160px]">
                <label>Periodicità *</label>
                <p-dropdown styleClass="w-full" [options]="periodicitaImpianto" formControlName="periodicita" optionLabel="label" optionValue="value" appendTo="body"></p-dropdown>
            </div>
            <div class="flex flex-col flex-1 min-w-[160px]">
                <label>Stato *</label>
                <p-dropdown styleClass="w-full" [options]="statiImpianto" formControlName="stato" optionLabel="label" optionValue="value" appendTo="body"></p-dropdown>
            </div>
        </div>
        <div class="flex gap-4 flex-wrap">
            <div class="flex flex-col flex-1 min-w-[200px]">
                <label>Ditta</label>
                <p-dropdown styleClass="w-full" [options]="rubricaDitte" formControlName="id_fornitore" optionLabel="ragione_sociale" optionValue="id" [showClear]="true" [filter]="true" filterBy="ragione_sociale" placeholder="Da assegnare" appendTo="body" (onChange)="onImpiantoFornitoreChange()"></p-dropdown>
            </div>
            <div class="flex flex-col flex-1 min-w-[200px]">
                <label>Incaricato (testo libero)</label>
                <input pInputText class="w-full" formControlName="incaricato" placeholder="Nome ditta o referente interno" />
            </div>
        </div>
        <div class="flex gap-4 flex-wrap">
            <div class="flex flex-col flex-1 min-w-[160px]">
                <label>Ultimo intervento</label>
                <p-calendar formControlName="ultimo_intervento" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body" styleClass="w-full"></p-calendar>
            </div>
            <div class="flex flex-col flex-1 min-w-[160px]">
                <label>Prossima scadenza</label>
                <p-calendar formControlName="prossima_scadenza" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body" styleClass="w-full"></p-calendar>
            </div>
            <div class="flex flex-col flex-1 min-w-[160px]">
                <label>Preavviso</label>
                <p-dropdown styleClass="w-full" [options]="preavvisiImpianto" formControlName="preavviso" optionLabel="label" optionValue="value" appendTo="body"></p-dropdown>
            </div>
        </div>
        <div class="flex flex-col">
            <label>Cosa deve essere verificato</label>
            <textarea pInputTextarea class="w-full" formControlName="checklist" rows="3" placeholder="Una voce per riga…"></textarea>
        </div>
        <div class="flex flex-col"><label>Note</label><textarea pInputTextarea class="w-full" formControlName="note" rows="2"></textarea></div>
        <div class="flex flex-col gap-1">
            <label>Documento / verbale di riferimento</label>
            <app-file-upload [form]="formImpianto" [control]="'documento'" [label]="''" [multiple]="false" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Carica documento'"></app-file-upload>
            @if (impiantoEdit?.documento) {
                <button type="button" class="doc-btn self-start" (click)="onDocumento(impiantoEdit!.documento!)">Apri attuale</button>
            }
        </div>
        <div class="acc-actions">
            <button type="button" class="acc-btn acc-btn-ghost" (click)="impiantoDialog = false">Annulla</button>
            <button type="submit" class="acc-btn acc-btn-primary" [disabled]="formImpianto.invalid">Salva verifica</button>
        </div>
    </form>
</p-dialog>

<!-- Scheda dettaglio impianto -->
<p-dialog [(visible)]="impiantoDetailDialog" styleClass="accrediti-dialog ac-impianto-detail" [modal]="true" [style]="{width: 'min(980px, 94vw)'}" [header]="impiantoDetail?.nome || 'Scheda verifica'">
    @if (impiantoDetail) {
        <p class="ac-subtitle mt-0">{{ impiantoDetail.descrizione || impiantoDetail.categoria }}</p>
        <div class="ac-detail-grid">
            <div>
                <div class="ac-info-grid">
                    <div class="ac-info"><label>Categoria</label><b>{{ impiantoDetail.categoria }}</b></div>
                    <div class="ac-info"><label>Periodicità</label><b>{{ periodicitaLabel(impiantoDetail.periodicita) }}</b></div>
                    <div class="ac-info"><label>Ultimo intervento</label><b>{{ impiantoDetail.ultimo_intervento ? (impiantoDetail.ultimo_intervento | date: 'dd/MM/yyyy') : '—' }}</b></div>
                    <div class="ac-info"><label>Prossima scadenza</label><b>{{ impiantoDetail.prossima_scadenza ? (impiantoDetail.prossima_scadenza | date: 'dd/MM/yyyy') : 'Da programmare' }}</b></div>
                    <div class="ac-info"><label>Ditta / incaricato</label><b>{{ impiantoDetail.fornitore || impiantoDetail.incaricato || '—' }}</b></div>
                    <div class="ac-info">
                        <label>Stato</label>
                        <span class="mini-pill" [ngClass]="impiantoStatusClass(impiantoDetail.stato_display || impiantoStatusLabel(impiantoDetail))">
                            {{ impiantoDetail.stato_display || impiantoStatusLabel(impiantoDetail) }}
                        </span>
                    </div>
                </div>
                <h3 class="ac-detail-h">Cosa deve essere verificato</h3>
                <ul class="ac-checklist">
                    @for (c of checklistItems(impiantoDetail); track c) {
                        <li>{{ c }}</li>
                    }
                </ul>
                <h3 class="ac-detail-h">Ultimi interventi</h3>
                <div class="ac-action-list">
                    @for (i of interventiImpianto; track i.id) {
                        <div class="ac-action-row">
                            <div>
                                <b>{{ i.data_ora | date: 'dd/MM/yyyy' }} · {{ tipoInterventoLabel(i.tipo) }}</b>
                                <span>{{ i.fornitore || '—' }}</span>
                            </div>
                            <span class="mini-pill" [ngClass]="esitoPillClass(i.esito)">{{ esitoLabel(i.esito) }}</span>
                        </div>
                    } @empty {
                        <div class="ac-mini-note">Nessun intervento collegato. Registrane uno per aggiornare le scadenze.</div>
                    }
                </div>
            </div>
            <aside class="ac-side-stack">
                <div class="ac-side-card">
                    <h3>Documenti</h3>
                    @if (impiantoDetail.documento) {
                        <div class="ac-doc-line">
                            <span class="ac-doc-icon">PDF</span>
                            <div><b>Documento di riferimento</b><small>allegato alla scheda</small></div>
                            <button type="button" class="acc-btn acc-btn-ghost" (click)="onDocumento(impiantoDetail.documento!)">Apri</button>
                        </div>
                    } @else {
                        <p class="ac-mini-note m-0">Nessun documento sulla scheda.</p>
                    }
                </div>
                <div class="ac-side-card">
                    <h3>Azioni</h3>
                    <button type="button" class="acc-btn acc-btn-primary w-full mb-2" (click)="impiantoDetailDialog = false; openNuovoIntervento(impiantoDetail)">Registra intervento</button>
                    <button type="button" class="acc-btn w-full mb-2" (click)="impiantoDetailDialog = false; openEditImpianto(impiantoDetail!)">Modifica scheda</button>
                    <p-confirmPopup key="deleteImpiantoDetail" #deleteImpiantoDetailPopup>
                        <ng-template pTemplate="headless" let-message>
                            <div class="border-round p-3">
                                <span class="text-base">{{ message.message }}</span>
                                <div class="flex align-items-center gap-2 mt-3">
                                    <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onCloseDeleteConfirm('impiantoDetail')">Annulla</button>
                                    <button type="button" class="acc-btn flex-1" (click)="onAcceptDeleteConfirm('impiantoDetail')">Elimina</button>
                                </div>
                            </div>
                        </ng-template>
                    </p-confirmPopup>
                    <button type="button" class="acc-btn w-full" (click)="deleteImpianto($event, impiantoDetail!)">Elimina</button>
                </div>
            </aside>
        </div>
    }
</p-dialog>

<!-- Dialog crea evento da rubrica -->
<p-dialog [(visible)]="creaEventoDialog" styleClass="accrediti-dialog" [modal]="true" [style]="{width: 'min(480px, 92vw)'}" header="Crea bozza evento">
    <form [formGroup]="formCreaEvento" class="accrediti-form flex flex-col gap-4" (ngSubmit)="saveCreaEvento()">
        @if (creaEventoRubrica) {
            <p class="text-sm text-gray-600">Da anagrafica: <strong>{{ creaEventoRubrica.ragione_sociale }}</strong></p>
        }
        <div class="flex flex-col"><label>Titolo evento *</label><input pInputText class="w-full" formControlName="evento" /></div>
        <div class="flex gap-4">
            <div class="flex flex-col flex-1"><label>Dal *</label><p-calendar formControlName="dal" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body" styleClass="w-full"></p-calendar></div>
            <div class="flex flex-col flex-1"><label>Al *</label><p-calendar formControlName="al" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body" styleClass="w-full"></p-calendar></div>
        </div>
        <div class="acc-actions">
            <button type="button" class="acc-btn acc-btn-ghost" (click)="creaEventoDialog = false">Annulla</button>
            <button type="submit" class="acc-btn acc-btn-primary" [disabled]="formCreaEvento.invalid">Crea</button>
        </div>
    </form>
</p-dialog>

<!-- MODAL DOCUMENTI TEATRO -->
<p-dialog [visible]="documenti" styleClass="accrediti-dialog" [style]="{width: '50%'}" header="Gestisci documenti Teatro" [modal]="true" class="p-fluid" (visibleChange)="documenti = false">
    <ng-template pTemplate="content">
        <form [formGroup]="formDocumenti" (ngSubmit)="onDocumenti()" class="accrediti-form flex flex-col gap-8">
            <div class="w-full flex flex-col gap-3">
                <label>Scheda Tecnica</label>
                <app-file-upload #uploadSchedaTecnica [form]="formDocumenti" [control]="'scheda_tecnica'" [label]="''" [multiple]="false" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Carica'"></app-file-upload>
                @if ((configurazione?.scheda_tecnica || '').toString().length > 0) {
                    <div class="doc-row ok mt-1">
                        <div class="doc-info">
                            <strong>Scheda Tecnica</strong>
                            <span class="doc-meta">caricato · clicca Apri per scaricare</span>
                        </div>
                        <span class="doc-stato ok">caricato</span>
                        <div class="doc-actions">
                            <button type="button" class="doc-btn" (click)="onDocumento((configurazione?.scheda_tecnica || '').toString())">Apri</button>
                            <button type="button" class="doc-btn doc-btn-danger" pTooltip="Rimuovi la scheda tecnica caricata" tooltipPosition="bottom" (click)="onOpenDeleteDocumento($event, 'scheda_tecnica')">Rimuovi</button>
                        </div>
                    </div>
                    <p-confirmpopup #deleteSchedaTecnica>
                        <ng-template pTemplate="headless" let-message>
                            <div class="border-round p-3">
                                <span class="text-base">{{ message.message }}</span>
                                <div class="flex align-items-center gap-2 mt-3">
                                    <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onCloseDeleteDocumento('scheda_tecnica')">Annulla</button>
                                    <button type="button" class="acc-btn flex-1" (click)="onDeleteDocumento('scheda_tecnica')">Elimina</button>
                                </div>
                            </div>
                        </ng-template>
                    </p-confirmpopup>
                }
            </div>
            <div class="w-full flex flex-col gap-3">
                <label>Duvri</label>
                <app-file-upload #uploadDuvri [form]="formDocumenti" [control]="'duvri'" [label]="''" [multiple]="false" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Carica'"></app-file-upload>
                @if ((configurazione?.duvri || '').toString().length > 0) {
                    <div class="doc-row ok mt-1">
                        <div class="doc-info">
                            <strong>DUVRI</strong>
                            <span class="doc-meta">caricato · clicca Apri per scaricare</span>
                        </div>
                        <span class="doc-stato ok">caricato</span>
                        <div class="doc-actions">
                            <button type="button" class="doc-btn" (click)="onDocumento((configurazione?.duvri || '').toString())">Apri</button>
                            <button type="button" class="doc-btn doc-btn-danger" pTooltip="Rimuovi il DUVRI caricato" tooltipPosition="bottom" (click)="onOpenDeleteDocumento($event, 'duvri')">Rimuovi</button>
                        </div>
                    </div>
                    <p-confirmpopup #deleteDuvri>
                        <ng-template pTemplate="headless" let-message>
                            <div class="border-round p-3">
                                <span class="text-base">{{ message.message }}</span>
                                <div class="flex align-items-center gap-2 mt-3">
                                    <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onCloseDeleteDocumento('duvri')">Annulla</button>
                                    <button type="button" class="acc-btn flex-1" (click)="onDeleteDocumento('duvri')">Elimina</button>
                                </div>
                            </div>
                        </ng-template>
                    </p-confirmpopup>
                }
            </div>
            <div class="w-full flex flex-col gap-3">
                <label>Facsimile autodichiarazione idoneità</label>
                <p class="text-sm text-color-secondary m-0">
                    File modello scaricabile dalle compagnie nel portale accreditamenti (sezione documenti teatro e form subappalti).
                </p>
                <app-file-upload #uploadFacsimile [form]="formDocumenti" [control]="'facsimile_autodichiarazione'" [label]="''" [multiple]="false" [accept]="'.doc,.docx,application/pdf,image/*'" [text]="'Carica'"></app-file-upload>
                @if ((configurazione?.facsimile_autodichiarazione || '').toString().length > 0) {
                    <div class="doc-row ok mt-1">
                        <div class="doc-info">
                            <strong>Facsimile autodichiarazione</strong>
                            <span class="doc-meta">caricato · disponibile nel portale compagnie</span>
                        </div>
                        <span class="doc-stato ok">caricato</span>
                        <div class="doc-actions">
                            <button type="button" class="doc-btn" (click)="onDocumento((configurazione?.facsimile_autodichiarazione || '').toString())">Apri</button>
                            <button type="button" class="doc-btn doc-btn-danger" (click)="onOpenDeleteDocumento($event, 'facsimile_autodichiarazione')">Rimuovi</button>
                        </div>
                    </div>
                    <p-confirmpopup #deleteFacsimile>
                        <ng-template pTemplate="headless" let-message>
                            <div class="border-round p-3">
                                <span class="text-base">{{ message.message }}</span>
                                <div class="flex align-items-center gap-2 mt-3">
                                    <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onCloseDeleteDocumento('facsimile_autodichiarazione')">Annulla</button>
                                    <button type="button" class="acc-btn flex-1" (click)="onDeleteDocumento('facsimile_autodichiarazione')">Elimina</button>
                                </div>
                            </div>
                        </ng-template>
                    </p-confirmpopup>
                }
            </div>
            <div class="acc-actions">
                <button type="button" class="acc-btn acc-btn-ghost" (click)="documenti = false">Annulla</button>
                <button type="submit" class="acc-btn acc-btn-primary" [disabled]="!formDocumenti.valid">Modifica</button>
            </div>
        </form>
    </ng-template>
</p-dialog>
